define('rebrush/components/product/options/group',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
], function(
	$,
	_,
	Component,
	BEM
) {

    function Group(block) {
        this.block = block;
        this.select = block.find('.' + BEM.buildElementClassname('product-options','option-wrap', 'option-select') + ' select');
        this.options = block.find('.option-group');

        this.init();
    }

    Group.prototype = {
        block: null,
        select: null,
        options: null,
        id: null,

        init: function () {
            let self = this;

            this.toggleOption(this.select.val());

            this.select.on('change', function () {
                let select = $(this);

                self.options.hide();
                self.toggleOption(select.val());
            });
        },

        toggleOption: function (optionId) {
            this.options.each(function () {
                let option = $(this);

                if (option.data('option-id').toString() === optionId) {
                    option.show();
                } else {
                    let input = option.find('input[name="options\[' + option.data('option-id') +'\]"]');

                    input.val('');
                    input.trigger('change');
                }
            });
        }
    };

    return Component.create({
        $init: function () {
            var blocks = $('.' + BEM.buildElementClassname('product-options', 'custom-option-list', 'grouped'));

            blocks.each(function () {
                let block = $(this);

                if (!block.data('option-group-id')) {
                    return;
                }

                new Group(block);
            });
        }
    });

});
